import { TickListProps } from '@kanda-libs/ks-design-library-new';

import { useCurrentJobLead } from 'hooks';

import { CLASS_NAMES } from './constants';

import type { CheckoutFinanceRate } from '../constants';

export interface SelectedRatePreApprovalMessageHook {
  preApproved: boolean;
  rows: TickListProps['rows'];
}

export default function useSelectedRatePreApprovalMessage(
  selectedRate: CheckoutFinanceRate,
): SelectedRatePreApprovalMessageHook {
  const { lead } = useCurrentJobLead();

  const preApproved =
    selectedRate?.provider === 'etika' &&
    selectedRate.enabled &&
    lead?.status === 'trade_accepted';

  const rows: TickListProps['rows'] = [
    !preApproved ? (
      <div className={CLASS_NAMES.item} key="not-approved">
        You have a{' '}
        <span className={CLASS_NAMES.itemEmphasised}>
          70% chance of being approved
        </span>{' '}
        for this plan.
      </div>
    ) : (
      ''
    ),
    preApproved ? (
      <div className={CLASS_NAMES.item} key="pre-approved">
        You have been pre-approved for this plan so you have a{' '}
        <span className={CLASS_NAMES.itemEmphasised}>
          90% chance of being accepted!
        </span>
      </div>
    ) : (
      ''
    ),
    <div className={CLASS_NAMES.item} key="no-costs">
      No costs if you are not approved
    </div>,
  ].filter(Boolean);

  return {
    preApproved,
    rows,
  };
}
